<div class="container-fluid">
  <app-header titleText="LEADS" i18n-titleText progressBarState="lead">
    <div button>
      <a *ngIf="canAddLead" routerLink="/lead/add" class="btn btn-bidit-navigate" i18n>Add Lead</a>
    </div>
  </app-header>

  <div class="card bg-light">
    <div class="card-body">
      <img src="assets/img/circle_images/leads_circle.png" alt="Lead Icon" class="card-icon" />
      <div class="form-inline">
        <h5 i18n>Lead List</h5>
        <div class="info-icon" i18n-matTooltip
             matTooltip="A sales lead is a potential sales contact who expresses interest in your business' product or services.  Customer information must be added before a lead is entered."></div>
      </div>

      <form class="row" (ngSubmit)="refreshSummary()">
        <div class="col-sm-3">
          <input name="projectName" id="projectName" class="form-control"
                 placeholder="Search Projects" i18n-placeholder
                 [(ngModel)]="filter.projectName" #projectName="ngModel" />
          <div class="">
            <label for="allLeads" class="mt-2" i18n>All Leads</label>
            <input id="pastDue" name="pastDue"
                   type="checkbox" class="bidit-switch m-2" (change)="refreshSummary()"
                   [(ngModel)]="filter.pastDue" #pastDue="ngModel" />
            <label for="pastDue" class="mt-2" i18n>Past Due</label>
          </div>
        </div>
        <div class="col-sm-3">
          <select name="dateRange" id="dateRange"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.dateRange" #dateRange="ngModel">
            <option value="null" i18n>Select Expiration Date Range</option>
            <option value="1" i18n>Current Month</option>
            <option value="2" i18n>Current Quarter</option>
            <option value="3" i18n>Current Year</option>
            <option value="4" i18n>Prior Month</option>
            <option value="5" i18n>Prior Quarter</option>
            <option value="6" i18n>Prior Year</option>
          </select>
        </div>
        <div class="col-sm-3">
          <select name="jobTypeId" id="jobTypeId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.jobTypeId" #jobTypeId="ngModel">
            <option value="null" i18n>Select Job Type</option>
            <option *ngFor="let jobType of summary?.jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
          </select>
        </div>
        <div class="col-sm-3">
          <select name="probability" id="probability"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.probability" #probability="ngModel">
            <option value="" i18n>Select Probability</option>
            <option value="H" i18n>High</option>
            <option value="M" i18n>Medium</option>
            <option value="L" i18n>Low</option>
          </select>
          <select name="salespersonId" id="salespersonId"
                  class="form-control select-bidit"
                  [(ngModel)]="filter.salespersonId" #salespersonId="ngModel">
            <option value="" i18n>Select Salesperson</option>
            <option *ngFor="let salesperson of summary?.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
          </select>
        </div>
        <div class="col-sm-3">
          <div class="container d-flex h-100">
            <div class="row justify-content-center align-self-center">
              <button type="submit" class="btn btn-bidit-action" onclick="this.blur();" i18n>Apply Filter</button>
            </div>
          </div>
        </div>
      </form>

      <h5 i18n>To modify lead list, use filters to customize</h5>
      <app-spinner [isRunning]="dataSource.loading$ | async"></app-spinner>

      <mat-table class="table-bidit table-striped" style="width: 100%;" [dataSource]="dataSource"
                 matSort matSortActive="projectName" matSortDirection="asc">
        <ng-container matColumnDef="projectName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Name</mat-header-cell>
          <mat-cell *matCellDef="let lead">
            <a routerLink="/lead/{{lead.quote_ID}}">
              {{lead.quote_Name}}
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="projectNbr">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Project Nbr</mat-header-cell>
          <mat-cell *matCellDef="let lead">
            {{lead.quote_ProjectNumber}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Customer</mat-header-cell>
          <mat-cell *matCellDef="let lead">
            {{lead.customer?.customer_BusinessName}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="jobType">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Job Type</mat-header-cell>
          <mat-cell *matCellDef="let lead">
            {{lead.jobType?.jobType_Desc}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="probability">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Probability</mat-header-cell>
          <mat-cell *matCellDef="let lead">
            {{lead.quote_Probability | convertProbability}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="startDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Start Date</mat-header-cell>
          <mat-cell *matCellDef="let lead">
            {{lead.quote_ReadyDate | date: 'M/d/yyyy'}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="expirationDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Expiration</mat-header-cell>
          <mat-cell *matCellDef="let lead">
            {{lead.quote_LeadDueDate | date: 'M/d/yyyy'}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="salesperson">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Salesperson</mat-header-cell>
          <mat-cell *matCellDef="let lead">
            <div>
              <div *ngFor="let quoteAssignment of lead.quoteAssignments">
                {{quoteAssignment.assignedTo.firstName}} {{quoteAssignment.assignedTo.lastName}}
              </div>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header"></mat-header-cell>
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let lead">
            <a *ngIf="canEditLead" routerLink="/lead/{{lead.quote_ID}}" class="btn btn-bidit-edit mr-1"></a>
            <a *ngIf="canAddQuote" routerLink="/lead/convert/{{lead.quote_ID}}" class="btn btn-bidit-navigate" i18n>Convert to Quote</a>
          </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns">
        </mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      <mat-paginator [length]="summary?.leadCount" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
    </div>
  </div>
</div>
